$(window).load(function() {
  $( ".inner_press_item" ).hover(
    function() {
      console.log('in');
      if ($( this ).find('.first_img').length) {
        $(this).find('.first_img').css('display','none');
        $(this).find('.hover_img').fadeIn()
      }
    }, function() {
      if ($( this ).find('.first_img').length) {
        $(this).find('.hover_img').css('display','none');
        $(this).find('.first_img').fadeIn();

      }
    }
  );
});